<template>
  <div class="tags-wrap">
    <div class="tags" ref="taglist">
      <p
        v-for="(tag,idx) in tags"
        :class="{selected:tag==currentTag}"
        :key="idx"
        @click="updateTag(tag)"
      >
        <span>{{tag | title}}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      default: function() {
        return this.$store.getters.tags;
      }
    },
    clear: {
      default: false
    },
    selected: {
      default: ""
    }
  },
  data() {
    return {
      currentTag: ""
    };
  },
  created() {
    this.currentTag = this.selected;
  },
  methods: {
    updateTag(tag) {
      if (this.currentTag == tag) {
        this.onClearFilter();
        return;
      }

      this.currentTag = tag;
      this.$emit("tagupdate", tag);
    },
    onClearFilter() {
      console.log("Emit Clear");
      this.$emit("onclear");
      this.$refs.taglist
        .querySelector(".selected")
        .classList.remove("selected");
      this.currentTag = "";
    }
  },
  filters: {
    title(val) {
      if (!val) return "";
      val = val.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-wrap {
  margin: 20px auto;
  .clear {
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
  }
  .tags {
    flex: 1;
  }
  &.pill {
    .tags {
      p {
        display: flex;
        align-items: center;
        i.material-icons {
          font-size: 1.5rem;
        }
        white-space: nowrap;
        padding: 7px 20px;
        margin-right: 1px;
        /* background-color: rgba(white, 0.15); */
        font-size: 1.5rem;
        &:first-child {
          border-top-left-radius: 999px;
          border-bottom-left-radius: 999px;
        }
        &:last-child {
          border-top-right-radius: 999px;
          border-bottom-right-radius: 999px;
        }
      }
    }
  }
}
.tags {
  /* background: #333; */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  grid-gap: 1px;
  padding: 1px;
  justify-content: center;
  align-items: center;
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    i.material-icons {
      cursor: pointer;
      /* pointer-events: none; */
    }
    transition: all 0.25s;
    &:hover {
      background: rgba(white, 0.2);
      color: white;
      cursor: pointer;
    }
    &.selected {
      background: #15755d;
      color: white;
    }
    &.clear {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: black;
    }
    font-weight: 300;
    color: rgba(white, 0.7);
    flex: 1;
    text-align: center;
    padding: 5px;
    background: rgba(white, 0.1);
    margin: 0;
  }
}
</style>
